import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import uniq from "lodash/uniq";
import { useMemo } from "react";
import { useQueryPayerRows } from "../../../query/search/payer/queries/useQueryPayerRows";
import { IPayerRow } from "../../../services/search";

export const usePayersMap = (workLogs: IWorkLog[] | undefined) => {
  const payerIds = useMemo(
    () => uniq((workLogs || []).map(workLog => workLog.payerId)),
    [workLogs]
  );

  const queryPayerRows = useQueryPayerRows(
    {
      filter: {
        payerId: {
          in: payerIds
        }
      }
    },
    {
      enabled: payerIds.length > 0
    }
  );

  const payersMap = useMemo(() => {
    const map = new Map<string, IPayerRow>();
    (queryPayerRows.data || []).forEach(payer => {
      map.set(payer.payerId, payer);
    });
    return map;
  }, [queryPayerRows.data]);

  return payersMap;
};
